import axios from "axios";
import ShowError from "../AppServices";
import { encerrarSessaoExpirada } from "../auth";

const PADRAO_CODIGO = /\b[0-9a-f]{32}\b/i;

function lerCabecalho(cabecalhos, nome) {
  if (!cabecalhos) return null;
  if (typeof cabecalhos.get === "function") return cabecalhos.get(nome) || null;
  const chave = Object.keys(cabecalhos).find((k) => k.toLowerCase() === nome);
  return chave ? cabecalhos[chave] : null;
}

// Devolve o código de rastreio (minúsculas) ou null. Prefere o cabeçalho X-Trace-Id.
export function extrairCodigoRastreio(cabecalhos, corpo) {
  const doCabecalho = lerCabecalho(cabecalhos, "x-trace-id");
  if (typeof doCabecalho === "string" && doCabecalho.trim()) {
    return doCabecalho.trim().toLowerCase();
  }
  const texto =
    typeof corpo === "string" ? corpo : corpo && typeof corpo.mensagem === "string" ? corpo.mensagem : "";
  const achado = PADRAO_CODIGO.exec(texto);
  return achado ? achado[0].toLowerCase() : null;
}

export function classificarErro({ cancelado, status, temResposta }) {
  if (cancelado) return "cancelado";
  if (!temResposta) return "comunicacao";
  if (status === 401) return "sessaoRecusada";
  if (status >= 500) return "servidor";
  return "negocio";
}

// Monta o argumento do ShowError para a janela de negócio, no formato que montarAvisoErro entende.
function montarPopupNegocio(corpo) {
  const base = { tipo: "negocio", central: true };
  if (Array.isArray(corpo)) return { ...base, erros: corpo };
  if (typeof corpo === "string") return { ...base, mensagem: corpo };
  if (corpo && typeof corpo === "object") return { ...corpo, ...base };
  return base;
}

// Devolve true quando o erro já foi tratado aqui.
export function tratarErroHttp({ cancelado, status, temResposta, cabecalhos, corpo, ehLogin }) {
  const tipo = classificarErro({ cancelado, status, temResposta });
  if (tipo === "negocio" && lerCabecalho(cabecalhos, "x-erro-negocio")) {
    ShowError(montarPopupNegocio(corpo));
    return true;
  }
  if (tipo === "servidor") {
    const codigoRastreio = extrairCodigoRastreio(cabecalhos, corpo);
    const popup = { tipo: "servidor", central: true };
    if (codigoRastreio) popup.codigoRastreio = codigoRastreio;
    ShowError(popup);
    return true;
  }
  if (tipo === "comunicacao") {
    ShowError({ tipo: "comunicacao", central: true });
    return true;
  }
  if (tipo === "sessaoRecusada" && !ehLogin) {
    encerrarSessaoExpirada();
    return true;
  }
  return false;
}

// Trata o erro de uma store do DevExtreme (argumento { xhr, error } do onAjaxError).
// Devolve true quando o erro já foi tratado aqui; nunca lança.
export function tratarErroAjaxStore(e) {
  const xhr = e && e.xhr;
  if (!xhr) return false;
  const status = xhr.status;
  let codigo = null;
  try {
    codigo = typeof xhr.getResponseHeader === "function" ? xhr.getResponseHeader("X-Trace-Id") : null;
  } catch (_) {
    codigo = null;
  }
  let marcaNegocio = null;
  try {
    marcaNegocio = typeof xhr.getResponseHeader === "function" ? xhr.getResponseHeader("X-Erro-Negocio") : null;
  } catch (_) {
    marcaNegocio = null;
  }
  let corpo = xhr.responseText;
  if (typeof corpo === "string" && corpo) {
    try {
      corpo = JSON.parse(corpo);
    } catch (_) {
      // corpo que não é JSON segue como texto
    }
  }
  return tratarErroHttp({
    cancelado: false,
    status,
    temResposta: typeof status === "number" && status > 0,
    cabecalhos:
      codigo || marcaNegocio
        ? {
            ...(codigo ? { "x-trace-id": codigo } : {}),
            ...(marcaNegocio ? { "x-erro-negocio": marcaNegocio } : {}),
          }
        : undefined,
    corpo,
    ehLogin: false,
  });
}

export function registrarTratamentoCentral(instanciaAxios, { rotaLogin } = {}) {
  instanciaAxios.interceptors.response.use(
    (resposta) => resposta,
    (error) => {
      const resposta = error && error.response;
      const url = error && error.config && error.config.url;
      tratarErroHttp({
        cancelado: axios.isCancel(error),
        status: resposta ? resposta.status : undefined,
        temResposta: !!resposta,
        cabecalhos: resposta ? resposta.headers : undefined,
        corpo: resposta ? resposta.data : undefined,
        ehLogin: !!rotaLogin && url === rotaLogin,
      });
      return Promise.reject(error);
    }
  );
}
